import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes.ts';

const router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes,
  history: createWebHistory(),
});

router.beforeEach((to, from, next) => {
  document.title = 'Lagerstyring - ' + to.meta?.title?.toString();
  
  // Clear table states when navigating between different main sections
  if (from.path && to.path) {
    // Define main sections (top-level routes)
    const mainSections = ['', 'scan', 'stock', 'orders', 'shop', 'purchasing', 'reception', 'settings'];
    
    const fromSection = from.path.split('/')[1] || '';
    const toSection = to.path.split('/')[1] || '';
    
    // If changing main section, clear all table states for the old section
    if (fromSection !== toSection && mainSections.includes(fromSection) && mainSections.includes(toSection)) {
      try {
        // Clear all session storage keys that start with table_state and belong to the old section
        const keysToRemove = [];
        for (let i = 0; i < sessionStorage.length; i++) {
          const key = sessionStorage.key(i);
          if (key && key.startsWith('table_state_')) {
            // Check if the key belongs to the old section
            const keyPath = key.replace('table_state_', '').replace(/_/g, '/');
            const keySection = keyPath.split('/')[1] || '';
            if (keySection === fromSection) {
              keysToRemove.push(key);
            }
          }
        }
        keysToRemove.forEach(key => sessionStorage.removeItem(key));
      } catch (e) {
        console.warn('Could not clear table states:', e);
      }
    }
  }
  
  next();
});

export default router;
